module.exports = __webpack_public_path__ + "img/molisana-desktop.049cf796.png";